import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, LayoutDashboard, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

export const Header = () => {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <header className="sticky top-0 z-50 bg-cream/90 backdrop-blur-xl border-b-2 border-ink" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px] gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="logo-link">
          <div className="w-10 h-10 bg-brand rounded-xl border-2 border-ink shadow-hard-sm flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="text-2xl font-black tracking-tighter font-heading">Snagly</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-bold text-sm">
          <Link to="/shop" className="hover:text-brand transition-colors" data-testid="nav-shop">Shop All</Link>
          <Link to="/shop?category=School%20Supplies" className="hover:text-brand transition-colors" data-testid="nav-school">Back to School</Link>
          <Link to="/shop?category=Collegiate" className="hover:text-brand transition-colors" data-testid="nav-collegiate">Collegiate</Link>
          <Link to="/shop?category=Electronics" className="hover:text-brand transition-colors" data-testid="nav-electronics">Electronics</Link>
          <Link to="/shop?category=Home" className="hover:text-brand transition-colors" data-testid="nav-home-cat">Home</Link>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          {user?.role === "admin" && (
            <Link to="/admin" className="hidden sm:flex items-center gap-1.5 text-sm font-bold px-3 py-2 rounded-full border-2 border-ink hover:bg-brand-yellow transition-colors" data-testid="nav-admin">
              <LayoutDashboard className="w-4 h-4" /> Admin
            </Link>
          )}
          <Link to="/cart" className="relative w-11 h-11 flex items-center justify-center rounded-full border-2 border-ink hover:bg-brand-yellow transition-colors" data-testid="cart-button">
            <ShoppingBag className="w-5 h-5" />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-brand-pink text-white text-xs font-black w-5 h-5 rounded-full flex items-center justify-center border-2 border-ink" data-testid="cart-count">{count}</span>
            )}
          </Link>
          {user ? (
            <div className="flex items-center gap-2">
              <Link to="/orders" className="hidden sm:flex items-center gap-1.5 text-sm font-bold px-3 py-2 rounded-full border-2 border-ink hover:bg-brand-green transition-colors" data-testid="nav-orders">
                <User className="w-4 h-4" /> {user.name.split(" ")[0]}
              </Link>
              <button onClick={handleLogout} className="w-11 h-11 flex items-center justify-center rounded-full border-2 border-ink hover:bg-brand-pink hover:text-white transition-colors" data-testid="logout-button" title="Log out">
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          ) : (
            <Link to="/login" className="text-sm font-bold px-5 py-2.5 rounded-full border-2 border-ink bg-brand text-white shadow-hard-sm hover:translate-y-[2px] hover:shadow-none transition-all" data-testid="login-nav-button">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
